import {Component, inject, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {Project, ProjectControllerService, User} from "../../../api";
import {faEllipsisVertical, faPenToSquare} from "@fortawesome/pro-solid-svg-icons";
import {Router} from "@angular/router";

import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {RoleAndPrivilegesPipe} from "../../../pipes/role-and-privileges.pipe";
import {
  BicDropdownComponent,
  BicDropdownElementComponent,
  BicDropdownTriggerDirective
} from "@buildinginformationcloud/bic-ui-components";

@Component({
  selector: 'app-user-projects',
  templateUrl: './user-projects.component.html',
  styleUrls: ['./user-projects.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FaIconComponent,
    RoleAndPrivilegesPipe,
    BicDropdownComponent,
    BicDropdownElementComponent,
    BicDropdownTriggerDirective,
    BicDropdownElementComponent
  ]
})
export class UserProjectsComponent implements OnInit {
  private projectControllerService = inject(ProjectControllerService);
  private router = inject(Router);


  @Input() user!: User;

  projects!: Project[];

  displayedColumns: string[] = ['name', 'role', 'actions'];
  dataSource!: MatTableDataSource<Project>;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('orgTbSort') orgTbSort = new MatSort();
  protected readonly faEllipsisVertical = faEllipsisVertical;
  protected readonly faPenToSquare = faPenToSquare;

  ngOnInit(): void {
    this.projectControllerService.getProjects().subscribe(projects => {
      this.projects = projects;
      this.dataSource = new MatTableDataSource(this.projects);
      this.dataSource.sort = this.sort;
    });
  }

  navigateToProjectSettings(project: Project) {
    this.router.navigate(['/projects', project.id, 'settings']);
  }

}
